document.addEventListener("turbolinks:load", () => {
    flatpickr('.datepicker', { 
        dateFormat: 'Y-m-d',
        maxDate: 'today'
    })
    $('form.reports input.filter').change(() => {
        console.log('submit!')
        $('form.reports').submit()
    })
})